<template>
  <div>
    <Head :title="title" />
    <div class="w-full my-5">
      <Breadcrumb
        :home="breadcrumb_home"
        :model="$page.props.breadcrumb_paths"
        v-if="category_side_menu_type == 'side'"
      />
    </div>
    <div
      class="flex flex-nowrap place-items-start"
      :class="[
        {
          'flex-row': category_side_menu_type == 'side',
          'flex-col': category_side_menu_type != 'side',
        },
      ]"
    >
      <div
        v-if="category_side_menu_type == 'side'"
        class="w-[180px] mr-5 shrink-0 border border-fh-gray hidden"
      >
        <div class="side_menu side_menu_root">
          {{ current_root_category.label }}
        </div>
        <side-sub-menu :items="current_root_category.items" />
      </div>
      <div v-else class="mx-auto w-full mb-5">
        <div class="top_menu top_menu_root" @click="toggleTopMenu">
          {{ current_root_category.label }}
          <i v-if="showTopMenu" class="pi pi-angle-down"></i
          ><i v-else class="pi pi-angle-right"></i>
        </div>
        <transition name="p-toggleable-content">
          <side-sub-menu
            v-show="showTopMenu"
            :items="current_root_category.items"
          />
        </transition>
      </div>
      <div class="min-w-[375px] max-w-[1080px]">
        <div
          class="flex flex-wrap justify-center md:justify-start place-items-start"
        >
          <Product
            class="w-[160px] md:w-[255px]"
            v-for="product in $page.props.products.data"
            :key="product.type + '_' + product.id"
            :show-quantity-input="true"
            price-tag="vertical"
            :price="product.price"
            :cv="product.cv"
            :type="product.type"
            :id="product.id"
            :name="product.name"
            :slug="product.slug"
            :quantity="product.quantity"
            :includes="product.includes"
            :attributes="product.attributes"
            :settings="product.settings"
            :relative-path="$page.url.split('?')[0] + '/products'"
            :images="product.images"
            :available="product.available"
          />
        </div>
      </div>
    </div>
    <div
      v-if="$page.props.products.total > $page.props.products.per_page"
      class="w-full mt-10 flex justify-around"
    >
      <Paginator :page-data="$page.props.products" />
    </div>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import Breadcrumb from "@/Shared/Components/Breadcrumb";
import SideSubMenu from "../Category/SideSubMenu";
import PanelMenu from "@/Shared/Components/PanelMenu";
import Product from "./Components/Product.vue";
import Paginator from "@/Shared/Paginator";
import { Link } from "@inertiajs/inertia-vue";

export default {
  components: {
    Breadcrumb,
    SideSubMenu,
    PanelMenu,
    Product,
    Paginator,
    "router-link": Link,
  },
  layout: Layout,
  data() {
    return {
      breadcrumb_home: {
        icon: "pi pi-home",
        to: "/",
      },
      windowWidth: window.innerWidth,
      showTopMenu: false,
    };
  },
  computed: {
    title() {
      return _.map(this.$page.props.breadcrumb_paths, "label").join(" > ");
    },
    current_root_category() {
      return this.$page.props.categories.find((category) => {
        return decodeURI(this.$page.url).includes(category.to);
      });
    },
    category_side_menu_type() {
      if (this.windowWidth >= 640) return "side";
      return "dropdown";
    },
    current_root_category_panel_menu() {
      return [this.current_root_category];
    },
  },
  methods: {
    toggleTopMenu() {
      this.showTopMenu = !this.showTopMenu;
    },
  },
  mounted() {
    fbq("track", "ViewContent", {
      content_name: "分類：" + this.title,
    });
    console.log("fbq.track.ViewContent", {
      content_name: "分類：" + this.title,
    });

    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
  },
};
</script>

<style lang="postcss">
.p-breadcrumb {
  @apply border-0;
}

.top_menu_root {
  @apply w-full px-4 py-2 bg-fh-blue text-white;
}

.side_menu_root {
  @apply px-4 py-2 bg-fh-blue text-white;
}

.side_menu li {
  @apply px-4 py-2 border-t border-fh-gray-border;
}

.side_menu_active {
  @apply bg-fh-gray-bg;
}

.side_menu_inactive {
  @apply bg-fh-gray-bg;
}

.side_menu_inactive:hover {
  @apply bg-fh-gray-light;
}
</style>